var _defs, _title;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(0, 0, 0)",
      fontFamily: "Arial, sans-serif",
      fontSize: 70
    },
    x: 4.9,
    y: 63.034
  }, "C"), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(0, 0, 0)",
      fontFamily: "Arial, sans-serif",
      fontSize: 55,
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    x: 63.3,
    y: 77.287,
    transform: "matrix(0, 1, -1, 0, 0, 0)"
  }, "p"), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    stroke: "#000",
    id: "line-1",
    y2: 18.785,
    x2: 64.628,
    y1: 43.512,
    x1: 64.628,
    fill: "none",
    style: {}
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    stroke: "#000",
    id: "line-2",
    y2: 18.785,
    x2: 72.616,
    y1: 43.514,
    x1: 72.616,
    fill: "none",
    style: {}
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    stroke: "#000",
    id: "line-3",
    y2: 18.785,
    x2: 80.603,
    y1: 43.516,
    x1: 80.603,
    fill: "none",
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.74a8fbe5323cdba956f4fff8968d305a.svg";
export { ForwardRef as ReactComponent };